import React from "react";
import { useTranslation } from "react-i18next";
import "./EstimatorHow.css";

const STEP_KEYS = ["s1", "s2", "s3", "s4"];

const EstimatorHow = () => {
  const { t } = useTranslation();

  const steps = STEP_KEYS.map((key, index) => ({
    number: String(index + 1).padStart(2, "0"),
    title: t(`sections.estimator.how.steps.${key}Title`),
    text: t(`sections.estimator.how.steps.${key}Text`),
  }));

  return (
    <section className="estimator-how">
      <div className="estimator-how__container">
        <span className="estimator-how__tag">{t("sections.estimator.how.tag")}</span>
        <h2 className="estimator-how__title">
          {t("sections.estimator.how.title")}{" "}
          <span>{t("sections.estimator.how.titleAccent")}</span>
        </h2>

        <div className="estimator-how__divider" />

        <div className="estimator-how__grid">
          {steps.map((step) => (
            <article className="estimator-how__card" key={step.number}>
              <p className="estimator-how__number">{step.number}</p>
              <div>
                <h3>{step.title}</h3>
                <p>{step.text}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="estimator-how__divider estimator-how__divider--bottom" />
      </div>
    </section>
  );
};

export default EstimatorHow;
